<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        WebShell 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">WebShell 목록</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail_search -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">등록 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_mod">활성화 상태</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['is_alive']" @change="refresh">
              <option disabled value=''>활성화 상태</option>
              <option value='true'>활성화</option>
              <option value='false'>비활성화</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_mod">바이너리</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['is_binary']" @change="refresh">
              <option disabled value=''>바이너리인지 아닌지 선택하세요</option>
              <option value='false'>바이너리 아님</option>
              <option value='true'>바이너리</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_ext">파일 확장자</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" label="ext" v-model="so.opt['ext']">
              <option value="1">Uncategorized</option>
              <option value="2">CGI Executable file</option>
              <option value="3">JSP/WAR</option>
              <option value="4">NodeJS</option>
              <option value="5">ASP/ASPX</option>
              <option value="6">PHP</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_category">분류</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" label="Category" v-model="so.opt['category']">
              <option value="1">Uncategorized</option>
              <option value="2">WebShell</option>
              <option value="3">SpamMail</option>
              <option value="4">FileManager</option>
              <option value="5">RansomeWare</option>
              <option value="6">Malware</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_name">이름</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_name" v-model="so.opt['name']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_ssdeep">SSDEEP</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_ssdeep" v-model="so.opt['ssdeep']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_md5">Hash(MD5)</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_md5" v-model="so.opt['md5']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_source">출처</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_source" v-model="so.opt['source']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center mt-2">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail_search -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 2.1rem"></span>{{model.total.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2">활성화 : <span style="padding-left: 1.3rem"></span>{{model.enable.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">비활성화 : <span style="padding-left: 0.5rem"></span>{{model.disable.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_danger mb-2">삭제 : <span style="padding-left: 2.1rem"></span>{{model.delete.toString().padStart(6, nbsp) | number}}</span>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="name">이름</option>
              <option value="md5">HASH</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mb7 mr-2 mt-2">
            <div class="custom-control custom-checkbox">
              <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
            </div>
          </div>
          <div class="mb7 mr-2 mt-2">
            <button type="button" class="btn btn-sm btn-addition" tabindex="4" @click="$router.push({ name: 'wsfinder_regist' })">
              등록
            </button>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="10">표시되는 개수 : 기본 10개</option>
              <option value=15>15</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="detail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            <template slot="is_alive" slot-scope="row">
              <b-badge variant="success" v-if="row.item.is_alive">On</b-badge>
              <b-badge variant="danger" v-else-if="row.item.is_del">삭제</b-badge>
              <b-badge v-else variant="secondary">Off</b-badge>
            </template>
            <template slot="ext" slot-scope="row">{{row.item.ext ? row.item.ext : '-'}}</template>
            <template slot="md5" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.md5}}</del>
              <span v-else>{{row.item.md5 ? row.item.md5 : '-'}}</span>
            </template>
            <template slot="name" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.name}}</del>
              <span v-else>{{row.item.name ? row.item.name : '-'}}</span>
            </template>
            <template slot="source" slot-scope="row">{{row.item.source ? row.item.source : 'F1security[default]'}}</template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>